import React from 'react';
import ReactDOM from 'react-dom';

import WebFont from 'webfontloader';
import { translate } from 'react-i18next';
import 'jquery/dist/jquery.min.js';
import 'jquery.cookie/jquery.cookie.js';

import $ from 'jquery';
import crypto from 'crypto';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-select/dist/react-select.css';

import './index.css';
import { unregister } from './registerServiceWorker';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// import './webrtc.js';

//  ----------------   custom components
import HomePage from './components/HomePage/HomePage';
import DashboardPage from './components/DashboardPage/DashboardPage';
import SocialMediaLogin from './components/SocialMediaPage/SocialLoginForm';
import RemoteLogin from './components/RemoteLogin/RemoteLogin';
import ContactUsPage from './components/ContactUs/contact-us';
// import VideoPage from './components/VideoPage/VideoPage';

import { flattenMessages } from './util';


import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

/**
 * Intercept all ajax call
 */

$.ajaxSetup({
  beforeSend: function (xhr) {
    if (localStorage.getItem('authToken')) {
      let nonce = new Date().getTime();
      let Authorization = localStorage.getItem('authToken');
      xhr.setRequestHeader('nonce', nonce);
      xhr.setRequestHeader('Authorization', Authorization);
    }
    let locale = 'EN';
    if (localStorage.getItem('locale') == 'Portuguese') {
      locale = 'PT'
    }
    if (localStorage.getItem('locale') == 'Spanish') {
      locale = 'SP'
    }
    if (localStorage.getItem('locale') == 'English') {
      locale = 'EN'
    }
    xhr.setRequestHeader('locale', locale);
    xhr.setRequestHeader('Content-type', 'application/json');
    if (!this.url.match("https://www.googleapis.com") && !this.url.match("https://graph.facebook.com")) {
      //$('#loader').removeClass('display-none');
    }
    if (this.url.match("https://www.googleapis.com")) {
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
      //$('#loader').removeClass('display-none');
    }
    if (this.url.match("https://api.instagram.com/")) {
      xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhr.setRequestHeader("Access-Control-Allow-Credentials", "true");
      xhr.setRequestHeader("Access-Control-Allow-Methods", "GET,HEAD,OPTIONS,POST,PUT");
      xhr.setRequestHeader("Access-Control-Allow-Headers", "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers");
    }
  },
  complete: function (xhr, status) {
    //   $('#loader').addClass('display-none');
  }
});

WebFont.load({
  google: {
    families: ['Lato', 'sans-serif']
  }
});

if (!localStorage.getItem('locale')) {
  localStorage.setItem('locale', 'English');
}


$("button").click(function () {
  $.get("demo_test.asp", function (data, status) {
    alert("Data: " + data + "\nStatus: " + status);
  });
});

ReactDOM.render(
  <I18nextProvider i18n={i18n()}>
    <Router>
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route path="/verify/email/:token" component={HomePage} />
        <Route path="/reset/password/:token" component={HomePage} />
        <Route path="/dashboard" component={DashboardPage} />
        <Route path="/social/media/login/:userid/:token" component={SocialMediaLogin} />
        <Route path="/remoteLogin/:q" component={RemoteLogin} />
        <Route path="/contact-us" component={ContactUsPage} />  
        {/* <Route path="/video" component={VideoPage} /> */}
        <Route component={HomePage} />
      </Switch>
    </Router>
  </I18nextProvider>,
  document.getElementById('root')
);

unregister();



// WEBPACK FOOTER //
// ./src/index.js